(function () {
  const index = Array.isArray(window.HEFT_SEARCH_INDEX) ? window.HEFT_SEARCH_INDEX : [];
  const productItems = index.filter((item) => item && item.type === "product");
  const enrichedPiecesBySku = {
    "25903s1": "3 pieces: left-arm facing sofa, wedge, right-arm facing sofa",
    "25903s2": "4 pieces: left-arm facing sofa, armless chair, wedge, right-arm facing sofa",
    "25903s3": "5 pieces: left-arm facing sofa, 2 armless chairs, wedge, right-arm facing sofa",
    "25903s4": "3 pieces: left-arm facing corner chaise, armless chair, right-arm facing corner chaise",
    "25903s5": "4 pieces: left-arm facing corner chaise, 2 armless chairs, right-arm facing corner chaise",
    "25903s6": "2 pieces: left-arm facing corner chaise, right-arm facing sofa",
    "25903s7": "2 pieces: left-arm facing sofa, right-arm facing corner chaise",
    "25903s8": "5 pieces: left-arm facing corner chaise, 2 armless chairs, wedge, right-arm facing sofa",
    "25903s9": "5 pieces: left-arm facing sofa, 2 armless chairs, wedge, right-arm facing corner chaise",
    "25903s16": "2 pieces: left-arm facing corner chaise, right-arm facing corner chaise",
    "25903s21": "6 pieces: left-arm facing corner chaise, wedge, 3 armless chairs, right-arm facing corner chair",
    "25903s22": "6 pieces: left-arm facing corner chair, wedge, 3 armless chairs, right-arm facing corner chaise",
    "25903s24": "5 pieces: left-arm facing corner chair, wedge, 2 armless chairs, right-arm facing corner chair"
  };

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function normalize(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function productHandle(title) {
    return normalize(title)
      .replace(/\b(ashley|signature|design|by|benchcraft)\b/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\s+/g, "-");
  }

  function productUrl(item) {
    return `/products/${productHandle(item.title)}`;
  }

  function familyName(title) {
    const clean = String(title || "").replace(/\s+/g, " ").trim();
    if (clean.includes(" - ")) return clean.split(" - ")[0].trim();
    return clean
      .replace(/\b(living room set|sectional set|sectional with ottoman|sofa, loveseat|sofa loveseat|sofa sleeper|sleeper sofa|stationary sofa|stationary loveseat|loveseat|sofa|sectional|oversized accent ottoman|accent ottoman|ottoman|chair and a half|arm chair|swivel chair|rocker recliner|recliner|chaise)\b.*$/i, "")
      .trim();
  }

  function exactCurrentItem(title, sku) {
    const currentSku = normalize(sku);
    const currentTitle = normalize(title);
    return productItems.find((item) => normalize(item.sku) === currentSku)
      || productItems.find((item) => normalize(item.title) === currentTitle)
      || null;
  }

  function pieceWeight(item) {
    const title = normalize(item.title);
    const sku = String(item.sku || "");
    if (title.includes("living room set") || title.includes("bedroom set") || title.includes("dining table set") || sku.includes("/")) return 0;
    if (title.includes("sectional")) return 1;
    if (title.includes("sleeper")) return 2;
    if (title.includes("sofa")) return 3;
    if (title.includes("loveseat")) return 4;
    if (title.includes("chair")) return 5;
    if (title.includes("recliner")) return 6;
    if (title.includes("ottoman")) return 7;
    if (title.includes("chaise")) return 8;
    return 12;
  }

  function pieceLabel(item) {
    const title = String(item.title || "");
    const parts = title.includes(" - ") ? title.split(" - ").slice(1).join(" - ") : title.replace(familyName(title), "").trim();
    return parts || title;
  }

  function includesProductNoun(value) {
    return /\b(sectionals?|sofas?|loveseats?|chaises?|chairs?|ottomans?|recliners?|beds?|dressers?|mirrors?|nightstands?|chests?|tables?|desks?|bookcases?|servers?|stools?|benches?|rugs?|lamps?|lights?|pillows?|art|clocks?|fireplaces?|stands?|centers?|sets?)\b/i.test(String(value || ""));
  }

  function skuKey(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function tidyIncludedPieces(value) {
    let source = String(value || "")
      .replace(/\s+/g, " ")
      .replace(/\s+and\s+/gi, ", ")
      .trim();
    if (!source) return "";

    source = source
      .replace(/^includes?\s+/i, "")
      .replace(/^kit includes?\s+/i, "")
      .replace(/^the set includes?\s+/i, "")
      .replace(/^this .*? includes?\s+/i, "")
      .replace(/\braf\b/gi, "right-arm facing")
      .replace(/\blaf\b/gi, "left-arm facing")
      .replace(/\buph\b/gi, "upholstered")
      .replace(/\bright arm facing\b/gi, "right-arm facing")
      .replace(/\bleft arm facing\b/gi, "left-arm facing")
      .replace(/\s+/g, " ")
      .trim();

    const countMatch = source.match(/^(\d+)\s+pieces?:\s*(.+)$/i);
    if (countMatch) return `${countMatch[1]} ${Number(countMatch[1]) === 1 ? "piece" : "pieces"}: ${countMatch[2].toLowerCase()}`;

    const setOfMatch = source.match(/\bset of\s+(\d+)\b/i);
    if (setOfMatch) {
      const count = Number(setOfMatch[1]);
      const details = source.replace(/\(?\bset of\s+\d+\b\)?/i, "").replace(/^[\s:,\-]+/, "").trim();
      return `${count} ${count === 1 ? "piece" : "pieces"}: ${details.toLowerCase()}`;
    }

    const inferred = source.includes(",") ? source.split(",").filter(Boolean).length : 1;
    return `${inferred === 1 ? "1 piece" : `${inferred} pieces`}: ${source.toLowerCase()}`;
  }

  function variantPieceCount(variantTitle) {
    const match = String(variantTitle || "").match(/\b(\d+)\s*(?:pc|piece|pieces)\b/i);
    return match ? Number(match[1]) : 0;
  }

  function scoreIncludedCandidate(candidate, variantTitle) {
    const text = normalize(candidate);
    const variant = normalize(variantTitle);
    let score = 0;
    const candidateCount = variantPieceCount(candidate);
    const selectedCount = variantPieceCount(variantTitle);

    if (candidateCount && selectedCount && candidateCount === selectedCount) score += 10;
    ["left arm", "right arm", "chaise", "sofa", "loveseat", "recliner", "chair", "ottoman", "wedge", "armless", "table", "stool", "bed", "dresser"].forEach((term) => {
      if (variant.includes(term) && text.includes(term)) score += 2;
    });
    return score;
  }

  function includedPiecesFromDescription(variantTitle) {
    const text = descriptionText();
    if (!text) return "";

    const matches = [];
    const pattern = /\b(?:Kit\s+)?Includes?\s+(?:(\d+)\s+pieces?:\s*)?(.+?)(?=\s+"Left-arm"|\s+Left-arm|\s+Corner-blocked|\s+Made of|\s+Assembly required|\.|$)/gi;
    let match;

    while ((match = pattern.exec(text)) !== null) {
      const raw = `Includes ${match[1] ? `${match[1]} pieces: ` : ""}${match[2] || ""}`;
      const tidy = tidyIncludedPieces(raw);
      if (tidy && includesProductNoun(tidy)) {
        matches.push({ text: tidy, score: scoreIncludedCandidate(raw, variantTitle) });
      }
    }

    if (!matches.length) return "";
    matches.sort((a, b) => b.score - a.score);
    return matches[0].text;
  }

  function cleanPieceSource(value) {
    let source = String(value || "").replace(/\s+/g, " ").trim();
    if (!source || source.toLowerCase() === "default title") return "";

    if (source.includes(" - ")) {
      const segments = source.split(" - ").map((segment) => segment.trim()).filter(Boolean);
      if (/^\d+\s*(?:pc|piece)/i.test(segments[0]) && segments.length > 1) {
        source = `${segments[0]} ${segments.slice(1).join(", ")}`;
      } else if (segments.length > 1 && includesProductNoun(segments[0]) && !includesProductNoun(segments[segments.length - 1])) {
        source = segments.slice(0, -1).join(" - ");
      } else {
        source = segments.slice(1).join(" - ") || source;
      }
    }

    if (source.includes(" - ")) {
      const segments = source.split(" - ").map((segment) => segment.trim()).filter(Boolean);
      if (segments.length > 1 && includesProductNoun(segments[0]) && !includesProductNoun(segments[segments.length - 1])) {
        source = segments.slice(0, -1).join(" - ");
      }
    }

    if (source.includes("/")) {
      const segments = source.split("/").map((segment) => segment.trim()).filter(Boolean);
      const pieceSegment = segments.find((segment) => /\b\d+\s*(?:pc|piece|pieces)\b/i.test(segment))
        || segments.find((segment) => includesProductNoun(segment));
      if (pieceSegment) source = pieceSegment;
    }

    return source.replace(/\bpc\./gi, "pc").replace(/\s+/g, " ").trim();
  }

  function readablePieceText(value, productType) {
    let source = cleanPieceSource(value) || cleanPieceSource(productType);
    if (!source) return "";

    const countMatch = source.match(/\b(\d+)\s*(?:pc|piece|pieces)\b/i);
    const setOfMatch = source.match(/\bset of\s+(\d+)\b/i);
    const count = countMatch ? Number(countMatch[1]) : (setOfMatch ? Number(setOfMatch[1]) : 0);
    let details = source
      .replace(/\b\d+\s*(?:pc|piece|pieces)\b\.?/i, "")
      .replace(/\(?\bset of\s+\d+\b\)?/i, "")
      .replace(/^[\s:,\-]+/, "")
      .replace(/\braf\b/gi, "right-arm facing")
      .replace(/\blaf\b/gi, "left-arm facing")
      .replace(/\buph\b/gi, "upholstered")
      .replace(/\bright arm facing\b/gi, "right-arm facing")
      .replace(/\bleft arm facing\b/gi, "left-arm facing")
      .replace(/\band a half\b/gi, "and-a-half")
      .replace(/\s*\/\s*/g, " / ")
      .replace(/\s*,\s*/g, ", ")
      .replace(/\s+/g, " ")
      .trim();

    if (!details) details = cleanPieceSource(productType) || "selected configuration";
    details = details.replace(/\b(sectionals|sofas|loveseats|chaises|chairs|ottomans|recliners|beds|dressers|mirrors|nightstands|chests|tables|desks|bookcases|servers|stools|benches|rugs|lamps|lights|pillows|clocks|fireplaces|stands|centers|sets)\b/gi, (match) => match.slice(0, -1));

    const inferredCount = count || (details.includes(",") ? details.split(",").filter(Boolean).length : 1);
    const label = inferredCount === 1 ? "1 piece" : `${inferredCount} pieces`;
    return `${label}: ${details.toLowerCase()}`;
  }

  function configurationFromTerms(item) {
    if (!item || !item.terms) return "";
    const matches = [];
    const pattern = /configuration\s+(.+?)(?=\s+(?:configuration|direct to consumer|furniture|material|orientation|product type|style|category|collection|color|brand|assembly)\b|$)/gi;
    let match;

    while ((match = pattern.exec(item.terms)) !== null) {
      const candidate = cleanPieceSource(match[1]);
      if (candidate && !matches.includes(candidate)) matches.push(candidate);
    }

    return matches[0] || "";
  }

  function termValues(item, key) {
    if (!item || !item.terms) return [];
    const values = [];
    const pattern = new RegExp(`\\b${key}\\s+(.+?)(?=\\s+(?:assembly|brand|category|collection|color|configuration|dimensions|direct to consumer|furniture|immersive view|living room|material|orientation|product type|sectionals|sofas|style|sold individually|couch|bedroom|dining)\\b|$)`, "gi");
    let match;

    while ((match = pattern.exec(item.terms)) !== null) {
      const value = String(match[1] || "").replace(/\s+/g, " ").trim();
      if (value && !values.includes(value)) values.push(value);
    }

    return values;
  }

  function titleColor(item) {
    const parts = String(item && item.title ? item.title : "").split(" - ").map((part) => part.trim()).filter(Boolean);
    return parts.length > 2 ? parts[parts.length - 1] : "";
  }

  function colorValues(item) {
    const values = termValues(item, "color");
    const named = titleColor(item);
    if (named && !/\b(sofa|loveseat|sectional|ottoman|chair|table|bed|dresser|mirror|nightstand|chest)\b/i.test(named)) values.unshift(named);
    return unique(values.map((value) => value.replace(/\bdarkgray\b/gi, "Dark Gray").replace(/\bsaddlebrown\b/gi, "Saddle Brown")).filter(Boolean));
  }

  function configurationValues(item) {
    return unique(termValues(item, "configuration")
      .map((value) => value
        .replace(/\braf\b/gi, "right-arm facing")
        .replace(/\blaf\b/gi, "left-arm facing")
        .replace(/\bpc\b/gi, "pc")
        .replace(/\s+/g, " ")
        .trim())
      .filter(Boolean));
  }

  function hasNativeOption(kind) {
    const selector = document.querySelector("[data-product-variants]");
    if (!selector) return false;
    return Array.from(selector.querySelectorAll("[data-visual-option-group]")).some((group) => {
      const name = normalize(group.dataset.optionName);
      if (kind === "color") return /\b(color|colour|finish)\b/.test(name);
      if (kind === "configuration") return /\b(arrangement|configuration|orientation|chaise)\b/.test(name);
      return false;
    });
  }

  function swatchClass(value) {
    const text = normalize(value);
    if (/\b(black|charcoal|graphite)\b/.test(text)) return "swatch-dark";
    if (/\b(gray|grey|slate|stone)\b/.test(text)) return "swatch-gray";
    if (/\b(white|pearl|ivory|chalk)\b/.test(text)) return "swatch-light";
    if (/\b(cream|beige|linen|sand|taupe)\b/.test(text)) return "swatch-cream";
    if (/\b(blue|navy|denim)\b/.test(text)) return "swatch-blue";
    if (/\b(green|sage|olive|pacific)\b/.test(text)) return "swatch-green";
    if (/\b(brown|chocolate|espresso|walnut|saddle)\b/.test(text)) return "swatch-brown";
    if (/\b(red|burgundy|wine)\b/.test(text)) return "swatch-red";
    if (/\b(gold|honey|oak|goldenrod)\b/.test(text)) return "swatch-gold";
    return "swatch-neutral";
  }

  function arrangementClass(value) {
    const text = normalize(value);
    const classes = [];
    if (/\b(left|laf)\b/.test(text)) classes.push("is-left");
    if (/\b(right|raf)\b/.test(text)) classes.push("is-right");
    if (/\bchaise\b/.test(text)) classes.push("is-chaise");
    if (/\bsuper\s+chaise\b/.test(text)) classes.push("is-super-chaise");
    if (/\bsofa\s*\/\s*chaise\b|\bsofa chaise\b/.test(text)) classes.push("is-sofa-chaise");
    if (/\b(corner|sectional)\b/.test(text)) classes.push("is-corner");
    if (/\bu shaped\b|\bu shape\b/.test(text)) classes.push("is-u-shape");
    return classes.join(" ");
  }

  function linkedOptionGroups(title, sku) {
    const current = exactCurrentItem(title, sku);
    const pieces = matchingPieces(title, sku);
    const currentSku = normalize(sku);
    const groups = [];

    if (!hasNativeOption("color")) {
      const colorMap = new Map();
      pieces.forEach((item) => {
        colorValues(item).forEach((color) => {
          const key = normalize(color);
          if (!key || colorMap.has(key)) return;
          colorMap.set(key, { label: color, item });
        });
      });
      if (colorMap.size > 1) {
        const currentColors = current ? colorValues(current).map(normalize) : [];
        const currentNamedColor = current ? normalize(titleColor(current)) : "";
        groups.push({
          type: "color",
          label: "Stocked color",
          values: Array.from(colorMap.values()).map((entry) => ({
            label: entry.label,
            url: productUrl(entry.item),
            active: normalize(entry.item.sku) === currentSku && (currentNamedColor ? currentNamedColor === normalize(entry.label) : currentColors.length === 1 && currentColors[0] === normalize(entry.label))
          }))
        });
      }
    }

    if (!hasNativeOption("configuration")) {
      const configMap = new Map();
      pieces.filter((item) => normalize(item.title).includes("sectional") || normalize(item.category).includes("sectional")).forEach((item) => {
        configurationValues(item).forEach((configuration) => {
          const key = normalize(configuration);
          if (!key || configMap.has(key)) return;
          configMap.set(key, { label: configuration, item });
        });
      });
      if (configMap.size > 1) {
        const currentConfigs = current ? configurationValues(current).map(normalize) : [];
        groups.push({
          type: "configuration",
          label: "Arrangement",
          values: Array.from(configMap.values()).map((entry) => ({
            label: entry.label,
            url: productUrl(entry.item),
            active: normalize(entry.item.sku) === currentSku && currentConfigs.length === 1 && currentConfigs[0] === normalize(entry.label)
          }))
        });
      }
    }

    return groups;
  }

  function renderLinkedOptions(panel) {
    const grid = panel.querySelector("[data-ashley-linked-options-grid]");
    if (!grid) return;

    const groups = linkedOptionGroups(panel.dataset.productTitle, panel.dataset.productSku);
    if (!groups.length) {
      panel.hidden = true;
      return;
    }

    panel.hidden = false;
    grid.innerHTML = groups.map((group) => {
      const values = group.values.map((value) => {
        if (group.type === "color") {
          return `<a class="ashley-color-option${value.active ? " is-selected" : ""}" href="${escapeHTML(value.url)}" aria-label="${escapeHTML(value.label)}" title="${escapeHTML(value.label)}"><span class="ashley-color-swatch ${swatchClass(value.label)}"></span></a>`;
        }
        return `<a class="ashley-arrangement-option ${value.active ? "is-selected" : ""} ${arrangementClass(value.label)}" href="${escapeHTML(value.url)}" title="${escapeHTML(value.label)}"><span class="ashley-arrangement-icon" aria-hidden="true"><i></i><b></b><em></em></span><small>${escapeHTML(value.label)}</small></a>`;
      }).join("");

      return `<div class="ashley-option-group ashley-option-group--${group.type === "color" ? "color" : "arrangement"}">
        <div class="ashley-option-group__title"><strong>${escapeHTML(group.label)}:</strong><span>${escapeHTML(group.values.find((value) => value.active)?.label || group.values[0].label)}</span></div>
        <div class="${group.type === "color" ? "ashley-color-options" : "ashley-arrangement-options"}">${values}</div>
      </div>`;
    }).join("");
  }

  function piecesIncludedText(title, sku, variantTitle, productType) {
    const current = exactCurrentItem(title, sku);
    const productPieces = readablePieceText(title, productType);
    const currentPieces = current ? readablePieceText(current.title, current.category) : "";
    const variantLooksLikeColor = variantTitle
      && !includesProductNoun(variantTitle)
      && !/\b\d+\s*(?:pc|piece|pieces)\b/i.test(String(variantTitle));
    const descriptionPieces = includedPiecesFromDescription(variantTitle);
    if (descriptionPieces) return descriptionPieces;

    const enrichedPieces = enrichedPiecesBySku[skuKey(sku)];
    if (enrichedPieces) return enrichedPieces;

    if (variantLooksLikeColor) {
      if (currentPieces && includesProductNoun(currentPieces)) return currentPieces;
      if (productPieces && includesProductNoun(productPieces)) return productPieces;
      const typedColorPieces = readablePieceText(productType, "");
      if (typedColorPieces && includesProductNoun(typedColorPieces)) return typedColorPieces;
      return "1 piece: selected item";
    }

    const variantPieces = readablePieceText(variantTitle, "");
    if (variantPieces && includesProductNoun(variantPieces)) return variantPieces;

    const configurationPieces = readablePieceText(configurationFromTerms(current), "");
    if (configurationPieces && includesProductNoun(configurationPieces)) return configurationPieces;

    const typedPieces = readablePieceText(productType, "");
    const itemPieces = current ? readablePieceText(pieceLabel(current), current.category) : "";
    if (typedPieces && /\b\d+\s+pieces\b/i.test(typedPieces) && includesProductNoun(typedPieces)) return typedPieces;
    if (itemPieces && includesProductNoun(itemPieces)) return itemPieces;
    if (productPieces && includesProductNoun(productPieces)) return productPieces;

    if (productPieces) return productPieces;
    return "1 piece: selected item";
  }

  function matchingPieces(title, sku) {
    const current = exactCurrentItem(title, sku);
    const base = familyName(current ? current.title : title);
    if (!base) return [];
    const familyKey = normalize(base);
    return productItems
      .filter((item) => normalize(familyName(item.title)) === familyKey)
      .sort((a, b) => pieceWeight(a) - pieceWeight(b) || String(a.title).localeCompare(String(b.title)));
  }

  function renderPicker(picker) {
    const grid = picker.querySelector("[data-ashley-piece-grid]");
    if (!grid) return;
    const currentSku = normalize(picker.dataset.productSku);
    const currentTitle = normalize(picker.dataset.productTitle);
    const currentPrice = document.querySelector("[data-variant-price]");
    const pieces = matchingPieces(picker.dataset.productTitle, picker.dataset.productSku);

    if (pieces.length < 2) {
      picker.hidden = true;
      return;
    }

    grid.innerHTML = pieces.map((item) => {
      const active = normalize(item.sku) === currentSku || normalize(item.title) === currentTitle;
      const displayPrice = active && currentPrice && currentPrice.textContent.trim() ? currentPrice.textContent.trim() : item.price;
      const image = item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}"/>` : "";
      return `<a class="ashley-piece-card${active ? " is-active" : ""}" href="${productUrl(item)}">
        <span class="ashley-piece-card__image">${image}</span>
        <span class="ashley-piece-card__copy">
          <em>${active ? "Selected" : "Option"}</em>
          <strong>${escapeHTML(pieceLabel(item))}</strong>
          <small>${escapeHTML(item.sku || "")}</small>
        </span>
        <span class="ashley-piece-card__price">${escapeHTML(displayPrice || "")}</span>
      </a>`;
    }).join("");
  }

  function renderPiecesIncluded(detail) {
    const row = document.querySelector("[data-pieces-included-row]");
    const output = document.querySelector("[data-pieces-included]");
    if (!row || !output) return;

    if (detail && detail.sku) row.dataset.productSku = detail.sku;
    if (detail && detail.title) row.dataset.variantTitle = detail.title;

    const text = piecesIncludedText(
      row.dataset.productTitle,
      row.dataset.productSku,
      row.dataset.variantTitle,
      row.dataset.productType
    );
    output.textContent = includesProductNoun(text) ? text : piecesIncludedText(
      row.dataset.productTitle,
      row.dataset.productSku,
      "",
      row.dataset.productType
    );
  }

  function syncActivePiecePrice(event) {
    const price = event && event.detail ? event.detail.price : "";
    if (!price) return;
    document.querySelectorAll(".ashley-piece-card.is-active .ashley-piece-card__price").forEach((node) => {
      node.textContent = price;
    });
  }

  function tidyNumber(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return value;
    return numeric % 1 === 0 ? String(numeric) : String(numeric);
  }

  function unique(values) {
    return values.filter((value, index) => values.indexOf(value) === index);
  }

  function descriptionText() {
    const description = document.querySelector(".ashley-product-description");
    return description ? description.innerText.replace(/\s+/g, " ").trim() : "";
  }

  function extractDimensionFacts(text) {
    const facts = [];
    const measurements = [];
    const weights = [];
    const dimensionPattern = /(\d+(?:\.\d+)?)"?\s*W\s*x\s*(\d+(?:\.\d+)?)"?\s*D\s*x\s*(\d+(?:\.\d+)?)"?\s*H(?:\s*-\s*(\d+(?:\.\d+)?)\s*lb)?/gi;
    let match;

    while ((match = dimensionPattern.exec(text)) !== null) {
      measurements.push(`${tidyNumber(match[1])}"W x ${tidyNumber(match[2])}"D x ${tidyNumber(match[3])}"H`);
      if (match[4]) weights.push(`${tidyNumber(match[4])} lb`);
    }

    const standaloneWeights = text.match(/\b\d+(?:\.\d+)?\s*lb\b/gi) || [];
    standaloneWeights.forEach((weight) => weights.push(weight.replace(/\s+/g, " ")));

    const cleanMeasurements = unique(measurements).slice(0, 2);
    const cleanWeights = unique(weights).slice(0, 2);

    if (cleanMeasurements.length) {
      facts.push({ label: cleanMeasurements.length > 1 ? "Measurements" : "Dimensions", value: cleanMeasurements.join(" / ") });
    }

    if (cleanWeights.length) {
      facts.push({ label: cleanWeights.length > 1 ? "Weights" : "Weight", value: cleanWeights.join(" / ") });
    }

    return facts;
  }

  function renderProductFacts() {
    const facts = document.querySelector("[data-ashley-product-facts]");
    const grid = document.querySelector("[data-ashley-product-facts-grid]");
    const dimensionsAccordion = document.querySelector("[data-ashley-dimensions-accordion]");
    const dimensionsOutput = document.querySelector("[data-ashley-dimensions-output]");
    if (!facts || !grid) return;

    const dimensionFacts = extractDimensionFacts(descriptionText());
    if (dimensionsAccordion && dimensionsOutput && !dimensionsOutput.textContent.trim() && dimensionFacts.length) {
      dimensionsOutput.innerHTML = dimensionFacts
        .map((fact) => `<p><strong>${escapeHTML(fact.label)}:</strong> ${escapeHTML(fact.value)}</p>`)
        .join("");
      dimensionsAccordion.hidden = false;
    }

    if (!grid.children.length) {
      facts.hidden = true;
    }
  }

  function stripDimensionLinesFromOverview() {
    const dimensionPattern = /\b\d+(?:\.\d+)?["”]?\s*W\s*x\s*\d+(?:\.\d+)?["”]?\s*D\s*x\s*\d+(?:\.\d+)?["”]?\s*H\b/i;
    const weightPattern = /\b\d+(?:\.\d+)?\s*lb\b/i;
    const measurementLinePattern = new RegExp(`${dimensionPattern.source}|${weightPattern.source}`, "i");

    document.querySelectorAll(".ashley-pdp-accordions details:first-child .rte, .ashley-product-description.rte").forEach((container) => {
      container.querySelectorAll("p, li").forEach((node) => {
        const text = node.textContent.replace(/\s+/g, " ").trim();
        const lines = text.split(/\s{2,}|\n+/).map((line) => line.trim()).filter(Boolean);
        if (lines.length && lines.every((line) => measurementLinePattern.test(line))) node.remove();
      });

      Array.from(container.childNodes).forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const lines = node.textContent
          .split(/\n+/)
          .map((line) => line.trim())
          .filter((line) => line && !measurementLinePattern.test(line));
        node.textContent = lines.length ? `${lines.join("\n")}\n` : "";
      });
    });
  }

  function parsePrice(text) {
    const value = Number(String(text || "").replace(/[^0-9.]/g, ""));
    return Number.isFinite(value) ? value : 0;
  }

  function formatMoney(value) {
    return value.toLocaleString("en-CA", {
      style: "currency",
      currency: "CAD",
      maximumFractionDigits: 2
    });
  }

  function renderMonthlyPricing() {
    document.querySelectorAll(".ashley-page .product-card").forEach((card) => {
      const price = card.querySelector(".price-row strong");
      const row = card.querySelector(".price-row");
      if (!price || !row || row.querySelector(".monthly-price")) return;

      const amount = parsePrice(price.textContent);
      if (!amount) return;

      const monthly = document.createElement("small");
      monthly.className = "monthly-price";
      monthly.textContent = `Approx. ${formatMoney(amount / 12)}/mo for 12 months* before taxes and fees`;
      row.appendChild(monthly);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-ashley-linked-options]").forEach(renderLinkedOptions);
    document.querySelectorAll("[data-ashley-piece-picker]").forEach(renderPicker);
    renderPiecesIncluded();
    renderProductFacts();
    stripDimensionLinesFromOverview();
    renderMonthlyPricing();
  });
  window.addEventListener("heft:variant-price-change", syncActivePiecePrice);
  window.addEventListener("heft:variant-price-change", (event) => renderPiecesIncluded(event.detail));
})();
